import DocumentIcon from "src/core/assets/images/documents/documentIcon.svg?react";
import ImageIcon from "src/core/assets/images/documents/imageIcon.svg?react";
import PptIcon from "src/core/assets/images/documents/pptIcon.svg?react";
import { FILE_EXTENSION_GROUPS } from "src/core/constants/general";

export const DocumentIconComponent: React.FC<{ extension: string }> = ({ extension }) => {
  if (FILE_EXTENSION_GROUPS["doc"].includes(extension)) {
    return <DocumentIcon className="text-blue-doc" />;
  } else if (FILE_EXTENSION_GROUPS["pdf"].includes(extension)) {
    return <DocumentIcon className="text-red-pdf" />;
  } else if (FILE_EXTENSION_GROUPS["excel"].includes(extension)) {
    return <DocumentIcon className="text-green-excel" />;
  } else if (FILE_EXTENSION_GROUPS["image"].includes(extension)) {
    return <ImageIcon />;
  } else if (FILE_EXTENSION_GROUPS["ppt"].includes(extension)) {
    return <PptIcon />;
  }

  return null;
};
